import React, { useState } from "react";
import { Outlet, redirect } from "react-router-dom";
import { init } from "../../redux/slices/auth-slice";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { getAuthToken, removeAuthToken } from "../../utils/helper/token";
import ErrorPage from "./Error";

const IndexPage = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const verifyToken = async () => {
      try {
        setLoading(true);
        const token = getAuthToken();
        if (token) {
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/api/user/auth`,
            {
              method: "GET",
              headers: {
                "x-access-token": token,
              },
            }
          );
          if (!response.ok) {
            if (response.status === 401) {
              removeAuthToken();
              redirect("/user-portal");
            } else {
              throw error;
            }
          } else {
            const resData = await response.json();
            const authData = resData.data;
            dispatch(init(authData));
          }
        }
      } catch (error) {
        setError("Something went wrong");
      } finally {
        setLoading(false);
      }
    };
    verifyToken();
  }, []);
  if (error) return <ErrorPage status={500} />;
  return <>{!loading && <Outlet />}</>;
};

export default IndexPage;
